import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/product/product-measure-unit`;

export const productMeasureUnitService = {
    listProductMeasureUnit: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/list-product-measure-units`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    lookupProductMeasureUnit: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/lookup-product-measure-units`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    getProductMeasureUnit: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-product-measure-unit`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    }
}
